"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function SearchIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M9.627,1.072a8.555,8.555,0,1,0,8.555,8.555A8.564,8.564,0,0,0,9.627,1.072Zm0,15.41a6.856,6.856,0,1,1,6.856-6.855A6.863,6.863,0,0,1,9.627,16.482Z" }),
        react_1.default.createElement("rect", { x: "18.856", y: "15.997", width: "1.699", height: "7.416", transform: "translate(-8.162 19.705) rotate(-45)" })));
}
exports.default = SearchIcon;
